/**
 * lazysizes configuration.
 *
 * Must be evaluated BEFORE `import 'lazysizes'`: the library grabs
 * `window.lazySizesConfig` by reference while its module runs and fills in the
 * defaults it is missing, so a later assignment is ignored. ES modules
 * evaluate in source order — the import above the lazysizes import in main.js
 * is what makes this work. Mutating the object afterwards does take effect:
 * lazysizes reads `expand` again on every pass.
 *
 * Without a config the lookahead is lazysizes' own fallback — 500px, or 370px
 * on a viewport narrower than 500px, i.e. less than half a phone screen. Every
 * section of this site is at least one viewport tall (20_global.sass), so the
 * only meaningful unit here is the viewport: two of them ahead means the next
 * section and the one after it are already loading while you read this one,
 * and lazysizes' own expFactor stretches that to three while the page is idle.
 *
 * The other half of this is that get_responsive_image() must NOT emit
 * `loading="lazy"` on an image lazysizes handles — see library/responsive-images.php.
 */

// Only an explicit Save-Data opt-in narrows the window. A merely slow
// connection needs a bigger head start, not a smaller one.
const frugal = navigator.connection?.saveData === true

/** Two viewports ahead: the next section and the one after it. */
const lookahead = () => Math.round(window.innerHeight * (frugal ? 1 : 2))

const config = { expand: lookahead() }

window.lazySizesConfig = config

window.addEventListener(
  'resize',
  () => {
    config.expand = lookahead()
  },
  { passive: true }
)
